module.exports = __webpack_public_path__ + "img/geboortekaart-op-maat-Aurore-meisje-goudfolie-foliedruk-drukwerk-1.ef394ef5.jpg";